module.exports = __webpack_public_path__ + "img/reports.b305601a.png";